<template>
  <div class="category-block">
    <div class="color-header">
      <div class="section-title">■ COLOR</div>
      <div class="color-actions">
        <input type="text" ref="colorHexInput" placeholder="#RRGGBB" maxlength="7" class="color-hex-input">
        <button ref="applyColorBtn" class="apply-color-btn">Apply</button>
      </div>
    </div>
    <div class="color-palette-direct">
      <div v-for="color in colors" :key="color" class="palette-color" :style="{ backgroundColor: color }" @click="selectColor(color)"></div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'pinia'   // 只导入 mapActions
import { useDesignStore } from '@/stores/designStore'

export default {
  name: 'ColorPalette',
  props: {
    currentSelectedPart: {
      type: String,
      default: 'front'
    }
  },
  data() {
    return {
      colors: [
        "#FFFF00", "#FF5F00", "#FF1493", "#ff3300", "#39FF14", "#FFFAFA", "#7f1d1d", "#b91c1c", "#dc2626", "#FF0000", "#ef4444", "#fca5a5",
        "#713f12", "#a16207", "#ca8a04", "#eab308", "#facc15", "#fef08a", "#002B49", "#262626", "#404040", "#525252", "#737373", "#a3a3a3",
        "#831843", "#be185d", "#db2777", "#FF1493", "#FF69B4", "#FFB6C1", "#7c2d12", "#c2410c", "#ea580c", "#f97316", "#fb923c", "#fdba74",
        "#14532d", "#15803d", "#16a34a", "#22c55e", "#4ade80", "#86efac", "#581c87", "#7e22ce", "#9333ea", "#a855f7", "#c084fc", "#d8b4fe",
        "#002B49", "#1e3a8a", "#2563eb", "#3b82f6", "#60a5fa", "#93c5fd", "#064e3b", "#047857", "#059669", "#10b981", "#34d399", "#6ee7b7",
        "#312e81", "#4338ca", "#4f46e5", "#6366f1", "#818cf8", "#a5b4fc", "#0c4a6e", "#0369a1", "#0284c7", "#0ea5e9", "#38bdf8", "#7dd3fc"
      ]
    }
  },
  // ❌ 删除 computed 块
  // computed: { ...mapState(useDesignStore, ['currentSelectedPart']) },
  methods: {
    ...mapActions(useDesignStore, ['setPartColor']),
    selectColor(color) {
      if (this.currentSelectedPart) {
        this.setPartColor(this.currentSelectedPart, color)
      } else {
        console.warn('No selected part for color change')
      }
    },
    initColorHexInput() {
      const colorHexInput = this.$refs.colorHexInput
      const applyColorBtn = this.$refs.applyColorBtn
      if (!colorHexInput || !applyColorBtn) return

      const isValidHexColor = (hex) => /^#[0-9A-Fa-f]{6}$/i.test(hex)

      const applyColorFromHex = () => {
        let hexValue = colorHexInput.value.trim()
        if (hexValue && !hexValue.startsWith('#')) hexValue = '#' + hexValue
        if (/^#[0-9A-Fa-f]{3}$/i.test(hexValue)) {
          hexValue = '#' + hexValue[1] + hexValue[1] + hexValue[2] + hexValue[2] + hexValue[3] + hexValue[3]
        }
        if (isValidHexColor(hexValue)) {
          if (this.currentSelectedPart) {
            this.setPartColor(this.currentSelectedPart, hexValue)
            colorHexInput.value = hexValue.toUpperCase()
          } else {
            alert('Please select a design area first (front, back, sleeve, etc.)')
          }
        } else {
          alert('Please enter a valid hex color code, e.g., #3b82f6')
          colorHexInput.focus()
        }
      }

      applyColorBtn.addEventListener('click', applyColorFromHex)
      colorHexInput.addEventListener('keypress', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault()
          applyColorFromHex()
        }
      })
    }
  },
  mounted() {
    this.initColorHexInput()
  }
}
</script>

<style scoped>
.color-palette-direct {
  display: grid;
  grid-template-columns: repeat(18, 1fr);
  gap: 4px;
  margin-top: 8px;
  max-height: 180px;
  overflow-y: auto;
  padding: 6px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}

.color-palette-direct .palette-color {
  aspect-ratio: 1 / 1;
  width: 100%;
  min-width: 0;
  border-radius: 6px;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
  border: 2px solid transparent;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.color-palette-direct .palette-color:hover {
  transform: scale(1.08);
  border-color: #3b82f6;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.section-title {
  font-size: 1.1rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.2px;
  color: #072a47;
  margin-bottom: 0.3rem;
  padding-left: 4px;
}

.category-block {
  margin-bottom: 0.6rem;
}

.apply-color-btn {
  background: #e0e7ff;
  border: 1px solid #c7d2fe;
  color: #3730a3;
  padding: 0.4rem 0.8rem;
  border-radius: 6px;
  font-size: 0.75rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.apply-color-btn:hover {
  background: #c7d2fe;
  border-color: #a5b4fc;
}

.color-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
}

.color-actions {
  display: flex;
  align-items: center;
  gap: 5px;
}

.color-hex-input {
  width: 120px;
  padding: 4px 8px;
  border-radius: 4px;
  border: 1px solid #ddd;
  font-size: 0.7rem;
  font-family: monospace;
}

.apply-color-btn {
  background: #e0e7ff;
  border: 1px solid #c7d2fe;
  color: #3730a3;
  padding: 0.4rem 0.8rem;
  border-radius: 6px;
  font-size: 0.75rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.apply-color-btn:hover {
  background: #c7d2fe;
  border-color: #a5b4fc;
}

.section-title {
  margin-bottom: 0;
}

/* 移动端适配：减少每行列数以适应小屏幕 */
@media (max-width: 850px) {
  .color-palette-direct {
    grid-template-columns: repeat(18, 1fr); 
    gap: 3px;
    max-height: 140px;
  }
}

@media (max-width: 550px) {
  .color-palette-direct {
    grid-template-columns: repeat(12, 1fr); /* 更小的屏幕改为9列 */
  }
}
</style>